import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultapacienteactual',
  templateUrl: './consultapacienteactual.component.html',
  styleUrls: ['./consultapacienteactual.component.scss']
})
export class ConsultapacienteactualComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
